export const useStore = () => ({
    checkNav: (payload) => {
        if(payload.title == "BIKES") {
            if(payload.pathName == '/collections/all-bikes') {
                return true
            }
            else if(payload.pathName == '/collections/road-bikes') {
                return true
              }
            else if(payload.pathName == '/collections/performance-racing') {
              return true
            }
            else if(payload.pathName == '/collections/triathlon-time-trial') {
              return true
            }
            else if(payload.pathName == '/collections/city-hybrid') {
              return true
            }
            else if(payload.pathName == '/collections/mountain-bikes') {
                return true
              }
              else if(payload.pathName == '/collections/full-suspension') {
                return true
              }
              else if(payload.pathName == '/collections/hardtail') {
                return true
              }
              else if(payload.pathName == '/collections/29-mountain-bikes') {
                return true
              }
              else if(payload.pathName == '/collections/27-5-mountain-bikes') {
                return true
              }
              else if(payload.pathName == '/collections/26-mountain-bikes') {
                return true
              }
              else if(payload.pathName == '/collections/electric-mountain-bikes') {
                return true
              }
              else if(payload.pathName == '/collections/cross-gravel-bikes') {
                return true
              }
              else if(payload.pathName == '/collections/7-12-years-24') {
                return true
              }
              else if(payload.pathName == '/collections/5-9-years-20') {
                return true
              }
              else if(payload.pathName == '/collections/2-6-years-12-16') {
                return true
              }
              else if(payload.pathName == '/collections/helmets') {
                return true
              }
              else if(payload.pathName == '/collections/cross-gravel-bikes-gravel') {
                return true
              }
              else if(payload.pathName == '/collections/gravel-bikes') {
                return true
              }
              else if(payload.pathName == '/collections/electric-bikes-electric-mountain-bikes') {
                return true
              }
              else if(payload.pathName == '/collections/electric-bikes-electric-mountain-bikes') {
                return true
              }
            
              
            // for (let i = 0; i < payload.sub_collections.length; i++) {
            //     for (let j = 0; j < payload.sub_collections[i].sub_collections.length; j++) {
            //         // console.log("1. result: ",payload.sub_collections[j].sub_collections[j].handle);
            //         // console.log("2. result: ",payload.pathName);
            //         if(payload.pathName == payload.sub_collections[i].sub_collections[j].handle) {
            //             return true
            //         }
            //         else {
            //             return false
            //         }
            //     }
            // }
        }
        else if(payload.title == "GEAR") {
            if(payload.pathName == '/collections/all-gear') {
                return true
            }
            else if(payload.pathName == '/collections/bike-gear') {
                return true
              }
            else if(payload.pathName == '/collections/accessories') {
              return true
            }
            else if(payload.pathName == '/collections/bags-panniers') {
              return true
            }
            else if(payload.pathName == '/collections/bottles-cages') {
              return true
            }
            else if(payload.pathName == '/collections/computers') {
                return true
              }
            else if(payload.pathName == '/collections/fenders') {
                return true
              }
              else if(payload.pathName == '/collections/lights') {
                return true
              }
              else if(payload.pathName == '/collections/locks') {
                return true
              }
              else if(payload.pathName == '/collections/racks') {
                return true
              }
              else if(payload.pathName == '/collections/trainers') {
                return true
              }
              else if(payload.pathName == '/collections/gear') {
                return true
              }
              else if(payload.pathName == '/collections/ride-gear') {
                return true
              }
              else if(payload.pathName == '/collections/kids-bikes') {
                return true
              }
              else if(payload.pathName == '/collections/bibs-shorts-tights') {
                return true
              }
              else if(payload.pathName == '/collections/gloves') {
                return true
              }
              else if(payload.pathName == 'collections/helmets') {
                return true
              }
              else if(payload.pathName == '/collections/jerseys') {
                return true
              }
              else if(payload.pathName == '/collections/socks') {
                return true
              }
              else if(payload.pathName == '/collections/ride-gear') {
                return true
              }
              else if(payload.pathName == '/collections/service-gear') {
                return true
              }
              else if(payload.pathName == '/collections/floor-mini-pumps') {
                return true
              }
              else if(payload.pathName == '"/collections/inflators-co2') {
                return true
              }
              else if(payload.pathName == '/collections/mini-tools') {
                return true
              }
              else if(payload.pathName == '/collections/service-parts') {
                return true
              }
              else if(payload.pathName == '/collections/shop-tools') {
                return true
              }
              else if(payload.pathName == '/collections/tubeless-accessories') {
                return true
              }
              else if(payload.pathName == '/collections/components') {
                return true
              }
              else if(payload.pathName == '/collections/brakes') {
                return true
              }
              else if(payload.pathName == '/collections/chainstay') {
                return true
              }
              else if(payload.pathName == '/collections/e-bike-gear') {
                return true
              }
              else if(payload.pathName == '/collections/grips-tape') {
                return true
              }
              else if(payload.pathName == '/collections/handlebars') {
                return true
              }
              else if(payload.pathName == '/collections/headsets') {
                return true
              }
              else if(payload.pathName == '/collections/kickstands') {
                return true
              }
              else if(payload.pathName == '/collections/pedals') {
                return true
              }
              else if(payload.pathName == '/collections/saddles') {
                return true
              }
              else if(payload.pathName == '/collections/seatposts') {
                return true
              }
              else if(payload.pathName == '/collections/stems') {
                return true
              }
              else if(payload.pathName == '/collections/tires') {
                return true
              }
              else if(payload.pathName == '/collections/tubes') {
                return true
              }
              else if(payload.pathName == '/collections/wheelsystems') {
                return true
              }
              else if(payload.pathName == '/collections/components') {
                return true
              }
                else if(payload.pathName == '/collections/rider-gear') {
                return true
              }
              else if(payload.pathName == '/collections/inflators-co2') {
                return true
              }
        }
        else if(payload.title == "STORES" && payload.handle === payload.pathName) {
            return true
        }
        else if(payload.title == "CONTACT" && payload.handle === payload.pathName) {
            return true
        }
    }
})